import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './ExhibitorProgress.css';

export const PROGRESS_NONE = 0; // Нет прогресса
export const PROGRESS_PART = 1; // Частичный прогресс
export const PROGRESS_FULL = 2; // Полностью заполнен
// Возвращает величину прогресса для экспонента (от 0 до 100)
// и объект легенды с расшифровкой заполненности профиля по
// каждому из элементов профиля и путем для редактирования.
export const GetExhibitorProgress = ( exhibitor ) => {
    let progress = 0;
    let legend = {
        logo: {
            path: '/cabinet/exhibitorview/' + exhibitor?._id,
            progress: PROGRESS_NONE,
        },
        brand:  {
            path: '/cabinet/exhibitoreditmain',
            progress: PROGRESS_NONE,
        },
        categories:  {
            path: '/cabinet/exhibitoreditcategories',
            progress: PROGRESS_NONE,
        },
        description:  {
            path: '/cabinet/exhibitoredittexts',
            progress: PROGRESS_NONE,
        },
        contacts:  {
            path: '/cabinet/exhibitoreditcontacts',
            progress: PROGRESS_NONE,
        },
        links:  {
            path: '/cabinet/exhibitoreditlinks',
            progress: PROGRESS_NONE,
        },
    };

    // Может оказаться что экспонент еще не записан в стор
    if(!exhibitor) return { progress, legend };

    if( exhibitor.logo ) {
        progress += 15;
        legend.logo.progress = PROGRESS_FULL;
    }

    if( exhibitor.brand ) {
        progress += 10;
        legend.brand.progress = PROGRESS_FULL;
    }

    // Учитываем только основные категории
    if( exhibitor.categories.find(i => i.type === 'main') ) {
        progress += 15;
        legend.categories.progress = PROGRESS_FULL;
    }

    if( exhibitor.links?.rutube ||
        exhibitor.links?.telegram ||
        exhibitor.links?.vk ||
        exhibitor.links?.yazen ||
        exhibitor.links?.youtube ) {
        progress += 5;
        legend.links.progress = PROGRESS_FULL;
    }

    if( exhibitor.brief?.ru && exhibitor.brief?.en ) progress += 15;
    if( exhibitor.about?.ru && exhibitor.about?.en ) progress += 15;
    if( exhibitor.descr?.ru ) progress += 5;
    if( exhibitor.descr?.en ) progress += 5;

    if( exhibitor.brief?.ru && exhibitor.brief?.en && 
        exhibitor.about?.ru && exhibitor.about?.en &&
        exhibitor.descr?.ru && exhibitor.descr?.en )
        legend.description.progress = PROGRESS_FULL;
    else if( exhibitor.brief?.ru || exhibitor.brief?.en || 
             exhibitor.about?.ru || exhibitor.about?.en ||
             exhibitor.descr?.ru || exhibitor.descr?.en )
             legend.description.progress = PROGRESS_PART;

    if( exhibitor.contacts?.country ) progress += 5;
    if( exhibitor.contacts?.city?.ru && exhibitor.contacts?.city?.en ) progress += 5;
    if( exhibitor.contacts?.phone ) progress += 2;
    if( exhibitor.contacts?.email ) progress += 2;
    if( exhibitor.contacts?.www ) progress += 1;

    if( exhibitor.contacts?.country && exhibitor.contacts?.www &&
        exhibitor.contacts?.city?.ru && exhibitor.contacts?.city?.en &&
        exhibitor.contacts?.phone && exhibitor.contacts?.email )
        legend.contacts.progress = PROGRESS_FULL;
    else if( exhibitor.contacts?.country || exhibitor.contacts?.www ||
             exhibitor.contacts?.city?.ru || exhibitor.contacts?.city?.en ||
             exhibitor.contacts?.phone || exhibitor.contacts?.email )
             legend.contacts.progress = PROGRESS_PART;

    return { progress, legend };
};

// Возвращает цвет индикатора в зависимости от прогресса
export const GetExhibitorProgressColor = ( progress ) => {
    let color = '#990033';
    if( progress > 20 ) color = '#b82d31';
    if( progress > 40 ) color = '#e77420';
    if( progress > 60 ) color = '#f69910';
    if( progress > 80 ) color = '#78b118';
    if( progress > 99 ) color = '#009933';
    return color;
};

// Компонент прогресса заполненности профайла экспонента
export const ExhibitorProgress = ({ exhibitor, title = false, useClick = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const color = [ '#aaa', '#f90', '#090' ];
    const { progress, legend } = GetExhibitorProgress(exhibitor);
    const backgroundColor = GetExhibitorProgressColor(progress);
    const width = progress + '%';

    return(
        <div className='ExhibitorProgress'>
            {title && <b>{t('progress.title')}</b>}
            <div className='progress'>
                <div style={{ width, backgroundColor }}>{width}</div>
            </div>
            <ul>
                {Object.entries(legend).map(([ key, { path, progress } ], index) => (
                    <li key={index}>
                        {/*
                            ВНИМАНИЕ: При клике на карточку экспонента
                            на главной странице экспонента, будет срабатывать
                            обработчик всей карточки, а не этот. И это правильно
                            т.к. там нет еще установки просматриваемого экспонента!
                        */}
                        <span onClick={() => { if(useClick) navigate(path) }}>
                            {t('progress.' + key)}
                        </span>
                        <Icon icon={faCheck} color={color[progress]} className='check'/>
                    </li>
                ))}
            </ul>
        </div>
    );
};

ExhibitorProgress.propTypes = {
    exhibitor: PropTypes.object.isRequired,
    title: PropTypes.bool,
    useClick: PropTypes.bool,
};

export default ExhibitorProgress;
